<template>
    <AffectationCaisseModal/>
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    
import AffectationCaisseModal from "@/components/GesCom/Affectation/AffectationCaisseModal.vue";

    export default defineComponent({
      name: "AffectationCaissePage",
      components: {
        
        AffectationCaisseModal,
      },
    });
  </script>